import { render, staticRenderFns } from "./giftcardreport.vue?vue&type=template&id=2c7b2d2a&"
import script from "./giftcardreport.vue?vue&type=script&lang=js&"
export * from "./giftcardreport.vue?vue&type=script&lang=js&"
import style0 from "./giftcardreport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports